import React from 'react';

// Constants
import ColorConstants from 'Wpds/colors/ColorConstants';

// Components
import { WpIcon } from 'Wpds/components/icon';
import { WpText } from 'Wpds/components/text';

// Styles
import './WorkspaceDetailsListWrapper.scss';

type Props = {
  title: string;
  icon?: string;
  iconColor?: string;
  list: Array<string>;
  highlightedItemTitle?: string;
  highlightedItemContent?: string;
  highlightedItemIcon?: string;
  highlightedItemIconColor?: string;
  qaTest?: string;
};

const WorkspaceDetailsListWrapper = ({
  title,
  list,
  icon,
  iconColor,
  highlightedItemContent,
  highlightedItemTitle,
  highlightedItemIcon,
  highlightedItemIconColor,
  qaTest,
}: Props) => {
  const baseClassName = 'WorkspaceDetailsListWrapper';

  return (
    <div className={baseClassName} data-test={qaTest}>
      <div className={`${baseClassName}__title`}>
        {icon && <WpIcon name={icon} size="lg" color={iconColor || ColorConstants.gray[900]} />}
        <WpText noMargin bold>
          {title}
        </WpText>
      </div>
      <ul className={`${baseClassName}__list`}>
        {list.map(item => (
          <li key={`${title.replace(/\s/g, '')}--${item.replace(/\s/g, '')}`}>
            <WpText noMargin variant="bodySm" color="gray-600">
              {item}
            </WpText>
          </li>
        ))}
        {highlightedItemContent && highlightedItemTitle && (
          <li>
            <span className={`${baseClassName}__list__strongest-team-contribution`}>
              {highlightedItemIcon && highlightedItemIconColor && (
                <WpIcon name={highlightedItemIcon} size="lg" color={highlightedItemIconColor} />
              )}
              <WpText noMargin variant="bodySm" bold>
                {highlightedItemTitle}
              </WpText>
            </span>
            <WpText qaTest="strongestIndividualContribution" noMargin variant="bodySm" color="gray-600">
              {highlightedItemContent}
            </WpText>
          </li>
        )}
      </ul>
    </div>
  );
};

export default WorkspaceDetailsListWrapper;
